module.exports = __webpack_public_path__ + "img/icon_no_brand_data.41d73139.png";